import { Divider } from '@mui/material'
import React, { useContext } from 'react'
import { TiposActivoContext } from '../../pages/catalogos/ActivosTipoPage'
import { TipoActivoComponent } from './TipoActivoComponent'

export const TablaTiposActivo = ({tiposActivo}) => {
  const {modalAgregaTipoActivo, setModalAgregaTipoActivo, setTipoActivoSel} = useContext(TiposActivoContext)

  return (
    <div
        style={{
            display:'column',
            maxWidth:700,
            marginTop:20,
            maxHeight:'60%',
            overflowY:'auto'
        }}
    >
      <div
        style={{
          display:'flex',
          flexDirection:'row'
        }}
      >
        <div
          style={{
            fontSize:14,
            fontWeight:'bold'
          }}
        >
          Tipo de Instalacion 
        </div>
      </div>
      <Divider />
      {
        tiposActivo?.map(tipoActivo => (
          <TipoActivoComponent tipoActivo={tipoActivo} />
        ))
      }
    </div>
  )
}
